import React, { useState, useContext, useEffect } from "react";
import HrHeader from "../components/hotelRepresentative/HrHeader";
import AppFooter from "../components/AppFooter";
import UserContext from "../contexts/UserContext";

import Utils from "./../Utils";

const HrLayout = ({ children }) => {
    const [loading, setLoading] = useState(Utils.isHR() && !Utils.hasBrand());
    const { userData } = useContext(UserContext);

    useEffect(() => {
        if(Utils.isHR() && !Utils.hasBrand()){
            window.location.href = process.env.PUBLIC_URL + '/hotel-representative-first-login';
        }
        if (userData == null || userData == undefined || userData == false) {
            window.location.href = process.env.PUBLIC_URL + '/';
        }
        window.setTimeout(() => setLoading(false), 1000);
    }, [userData]);

    return (
        <div className="ftbottom">
            {loading && <div className="text-center">loading.. </div>}
            {!loading && <>
                <HrHeader />
                {children}
                <AppFooter />
            </>}
        </div>
    );
};

export default HrLayout;
